import React from "react";
import Grid from "@material-ui/core/Grid";
import { Toolbar } from "@material-ui/core";
import { Container, PrimaryButton } from "@prestosports/commons-ui";
import { useFormik } from "formik";
import GameConfig from "../GameConfig";
import SubmitCancelListener from "../listeners/SubmitCancelListener";

const GameConfigSelector = ({
	selected = {},
	onSelected = () => {},
	disableKeyListener
}) => {
	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			settings: selected
		},
		validate: (values) => {
			const errors = {};

			if (!values.settings.tossWinner) {
				errors.settings = "Toss winner is required";
			}
			if (!values.settings.offenseTeam) {
				errors.settings = "Offense team is required";
			}

			return errors;
		},
		onSubmit: (values) => {
			onSelected(values.settings);
		}
	});

	const { handleSubmit, setFieldValue, errors, touched, setTouched } = formik;

	const hasErrors = () => {
		return !!Object.keys(errors).length;
	};
	const submitDisabled = !touched.settings || hasErrors();

	return (
		<Container fullHeight noPaper>
			<form onSubmit={handleSubmit}>
				<GameConfig
					settings={formik.values.settings}
					onChange={(settings) => {
						setFieldValue("settings", settings);
						setTouched({ settings: true }, false);
					}}
					title="Coin Toss"
					subtitle="Select the coin toss winner and the team possession"
					hideSwapTeams
				/>
				<Toolbar disableGutters variant="dense">
					<Grid
						container
						direction="row"
						justifyContent="flex-end"
						alignItems="center"
					>
						<Grid item>
							<PrimaryButton type="submit" label="Save" disabled={submitDisabled} />
						</Grid>
					</Grid>
				</Toolbar>
				{!disableKeyListener && (
					<SubmitCancelListener
						onSubmit={handleSubmit}
						submitDisabled={submitDisabled}
					/>
				)}
			</form>
		</Container>
	);
};

export default GameConfigSelector;
